export interface Cadence {
  intervalMs: number;
  urgent: boolean;
}

/** Choose pulse cadence from remaining seconds. */
export function selectCadence(timeLeft: number): Cadence {
  if (timeLeft < 60) return { intervalMs: 5000, urgent: true };
  return { intervalMs: 15000, urgent: false };
}

/**
 * Attach pulse + urgent classes to `el` based on the most recent `timeLeft`
 * broadcast. Returns a dispose function that clears the internal timer.
 *
 * Caller must invoke `.tick(timeLeft)` whenever a `progress` message arrives.
 */
export function attachBlinkBorder(el: HTMLElement): {
  tick(timeLeft: number): void;
  dispose(): void;
} {
  let cadence: Cadence = selectCadence(Number.POSITIVE_INFINITY);
  let lastPulseAt = 0;
  let rafHandle: number | null = null;

  const pulse = () => {
    el.classList.remove("pulse");
    void el.offsetWidth;
    el.classList.add("pulse");
  };

  const schedule = () => {
    const loop = () => {
      const now = performance.now();
      if (now - lastPulseAt >= cadence.intervalMs) {
        lastPulseAt = now;
        pulse();
      }
      rafHandle = requestAnimationFrame(loop);
    };
    rafHandle = requestAnimationFrame(loop);
  };

  schedule();

  function tick(timeLeft: number) {
    const next = selectCadence(timeLeft);
    if (next.urgent !== cadence.urgent) {
      el.classList.toggle("urgent", next.urgent);
    }
    cadence = next;
  }

  function dispose() {
    if (rafHandle !== null) cancelAnimationFrame(rafHandle);
    el.classList.remove("pulse", "urgent");
  }

  return { tick, dispose };
}
